<template>
    <div>
        <app-data-table
            v-if="!!tableData"
            :fields="fields"
            :items="tableData.data"
            :from="tableData.from"
            :to="tableData.to"
            :current-page="tableData.current_page"
            :last-page="tableData.last_page"
            :total="tableData.total"
            :per-page="tableData.per_page"
            :on-change-page="onChangePage"
            @sort="onSort"
        >
            <template slot="id" slot-scope="{ item }">{{
                `${item.id}`.padStart(4, '0')
            }}</template>
            <template slot="actions" slot-scope="{ item }">
                <b-btn
                    size="sm"
                    v-if="
                        !(
                            item.ticket_status.slug === 'cerrado' ||
                            item.ticket_status.slug === 'finalizado'
                        )
                    "
                    variant="primary"
                    @click="$emit('edit', item)"
                >
                    <i class="fa fa-pencil"></i>
                </b-btn>
                <b-btn
                    size="sm"
                    variant="danger"
                    @click="$emit('delete', item)"
                >
                    <i class="fa fa-trash"></i>
                </b-btn>
            </template>
            <template slot="created_at" slot-scope="{ item }">
                {{ item.created_at | datetime('DD/MM/YYYY HH:mm') }}
            </template>
        </app-data-table>
        <b-alert show v-else>Esperando datos...</b-alert>
    </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: [String, Object],
            default: '',
        },
        onChangePage: {
            type: Function,
        },
    },
    data: () => ({
        fields,
    }),
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
const fields = [
    {
        key: 'id',
        label: 'ID',
        orderBy: 'tickets.id',
    },
    {
        key: 'created_at',
        label: 'Fecha de creación',
        orderBy: 'tickets.created_at',
    },
    {
        key: 'title',
        label: 'Titulo',
        orderBy: 'tickets.title',
    },
    {
        key: 'error_type',
        label: 'Tipo de Error',
        orderBy: 'tickets.error_type',
    },
    {
        key: 'user.name',
        label: 'Usuario',
        orderBy: 'user.name',
    },
    {
        key: 'attendant',
        label: 'Atendido por',
        orderBy: 'attendant',
    },
    {
        key: 'ticket_status.name',
        label: 'Estado',
        orderBy: 'ticket_status.name',
    },
    {
        key: 'ticket_priority.name',
        label: 'Prioridad',
        orderBy: 'ticket_priority.name',
    },
    {
        key: 'module.name',
        label: 'Modulo',
        orderBy: 'module.name',
    },
    {
        key: 'description',
        label: 'Descripcion',
        orderBy: 'tickets.description',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
